<template>
  <simple-page header="行政区划管理"
               class="area-page">
    <template #west>
      <area-tree ref="areaTree" editable style="width: 350px"
                @node-change="nodeChange"
                @add-child="addChild"
                @delete="onDelete"></area-tree>
    </template>

    <el-form ref="editForm" :model="currentItem" :rules="rules" label-width="120px" v-if="currentItem">
      <el-form-item prop="areaCode" label="行政区划编码">
        <el-input v-model.trim="currentItem.areaCode" :minlength="6" :maxlength="12" clearable></el-input>
      </el-form-item>
      <el-form-item prop="areaName" label="行政区划名称">
        <el-input v-model.trim="currentItem.areaName" placeholder="如：xx省/xx市/xx县" :maxlength="30" clearable></el-input>
      </el-form-item>
      <el-form-item prop="areaFullName" label="行政区划全称">
        <el-input v-model.trim="currentItem.areaFullName" placeholder="如：xx省xx市xx县" :maxlength="30" clearable></el-input>
      </el-form-item>
      <el-form-item prop="areaLevel" label="行政区划层级">
        <code-select code-type="areaLevel" disabled v-model="currentItem.areaLevel"></code-select>
      </el-form-item>
      <el-form-item label="上级区划">
        <span>{{currentItem.parentName}}</span>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-switch v-model="currentItem.valid"></el-switch>
      </el-form-item>
      <div class="button-container">
        <btn-save @click="save"></btn-save>
<!--        <btn-delete @click="del"></btn-delete>-->
      </div>
    </el-form>
    <el-empty v-else description="请点击左侧行政区划树进行编辑">
    </el-empty>
  </simple-page>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import CodeSelect from "@/components/base/CodeSelect";
import SimplePage from "@/components/page/SimplePage.vue";
import BtnSave from "@/components/btns/BtnSave.vue";
import BtnDelete from "@/components/btns/BtnDelete.vue";
import AreaTree from "@/components/area/AreaTree.vue";

export default {
  components: {AreaTree, BtnDelete, BtnSave, SimplePage, CodeSelect},
  extends: BaseVue,
  data() {
    return {
      parentNode: null,
      currentNode: null,
      currentItem: null,
      queryForm: {
        areaName: "",
        page: 1,
        limit: 10
      },
      rules: {
        areaCode: [{required: true, message: "行政区划编码不能为空", trigger: "blur"}],
        areaName: [{required: true, message: "行政区划名称不能为空", trigger: "blur"}],
        areaLevel: [{required: true, message: "行政区划层级不能为空", trigger: "change"}],
        areaFullName: [{required: true, message: "行政区划全称不能为空", trigger: "blur"}]
      }
    }
  },
  created() {
  },
  methods: {
    nodeChange(data, node){
      this.parentNode = null;
      this.currentNode = node;
      this.currentItem = Object.assign({},data);
      this.currentItem.parentName = node.parent.data ? node.parent.data.areaName : "--";
    },
    addChild(data, node) {
      this.currentNode = null;
      this.parentNode = node;
      let areaLevel = "1";
      if(data && data.areaLevel === "1") {
        areaLevel = "2";
      } else if(data && data.areaLevel === "2") {
        areaLevel = "3";
      } else if(data && data.areaLevel === "3") {
        areaLevel = "4";
      }
      this.currentItem = {
        parentCode: data ? data.areaCode : null,
        parentName: data ? data.areaName : "--",
        areaLevel: areaLevel,
        valid: true
      }
    },
    save() {
      this.$refs["editForm"].validate().then(()=>{
        this.loading = true;
        this.postForm("/area/save", this.currentItem, true).then(dr => {
          this.currentItem = dr.bean;
          if(this.currentNode) {
            Object.assign(this.currentNode.data, this.currentItem);
          } else {
            this.$refs["areaTree"].append(this.currentItem, this.parentNode);
            this.parentNode = null;
          }
        }).finally(()=>{
          this.loading = false;
        })
      });
    },
    //删除
    del() {
      this.$confirm("确定要删除选中组织机构吗？","系统提示", {type:"warning"}).then(() => {
        this.loading = true;
        this.postForm("/area/delete", {
          areaCode: this.currentItem.areaCode
        }, true).then((dr) => {
          this.onDelete();
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    onDelete(data){
      this.currentItem = null;
      this.currentNode = null;
    }
  }
}
</script>

<style scoped lang="scss">
.area-page{
  .area-tree-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
